import { createContext, useContext } from 'react';

const TherapistContext = createContext();

export const useTherapistCtx = () => useContext(TherapistContext);

export default TherapistContext;
